<div class="bg-white mx-5 px-5 py-3">
  <h5 *ngIf="title" class="mb-5">{{ title }}</h5>

  <form autocomplete="off">
    <formly-form [fields]="fields" [model]="model"></formly-form>
  </form>

  <ng-content></ng-content>
</div>
